// extracted by mini-css-extract-plugin
export var discard = "_3o-3";
export var muiTooltipTooltip = "_3o-5";
export var notificationBar = "_3o-2";
export var saveButtonHoverSlotWrapper = "_3o-4";
export var show = "_3o-1";
export var spacer = "_3o-0";